import './NoAccessResourcesModal.scss';
import { Modal, ModalBody } from 'reactstrap';
import InstructionBubble from '../Displays/InstructionBubble/InstructionBubble';
import { AlpLogoSpinningCryingGif } from '@project/helpers/imagePreloader';

interface NoAccessResourcesModalProps {
  show: boolean;
  authenticated?: boolean;
  onClose(): void;
  link1?: string;
  link2?: string;
  elementGroupResourceId?: string;
}

function NoAccessResourcesModal({ show, onClose, authenticated = false, link1, link2 }: NoAccessResourcesModalProps) {
  return (
    <Modal className="alp-modal" isOpen={show} toggle={() => onClose()} backdrop="static" centered>
      <ModalBody>
        <InstructionBubble movingpic={AlpLogoSpinningCryingGif}>
          {!authenticated ?
            <>
              <div className="flex-space-between">
                <h6 className="green fw-bold">You must be logged in to access or view the resource.</h6>
                <i className="icon icon-close clickable" onClick={() => onClose()} />
              </div>
              <p>
                <div>Please <a href={link1} className="green underline">Login</a> to continue, or <a href={link2} className="green underline">Create an Account</a> to Subscribe to a Resource.</div>
              </p>
            </> :
            <>
              <div className="flex-space-between">
                <h6 className="green fw-bold">Buy this resource to access it.</h6>
                <i className="icon icon-close clickable" onClick={() => onClose()} />
              </div>
              <p>
                <div>Click <a href={link1} className="green underline">here</a> to buy now.</div>
              </p>
            </>
          }
        </InstructionBubble>
      </ModalBody>
    </Modal>
  );
}

export default NoAccessResourcesModal;
